import { render, staticRenderFns } from "./claim-new.vue?vue&type=template&id=b2542a56&scoped=true"
import script from "./claim-new.vue?vue&type=script&lang=js"
export * from "./claim-new.vue?vue&type=script&lang=js"
import style0 from "./claim-new.vue?vue&type=style&index=0&id=b2542a56&prod&lang=css"
import style1 from "./claim-new.vue?vue&type=style&index=1&id=b2542a56&prod&lang=scss&scoped=true"
import style2 from "./claim-new.vue?vue&type=style&index=2&id=b2542a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2542a56",
  null
  
)

export default component.exports